import * as React from 'react'

import { cn } from '@/lib/utils'

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        data-slot="control"
        className={cn(
          'flex min-h-[80px] w-full rounded-md px-4 py-3 text-sm text-txt-primary shadow-input-default outline-none placeholder:text-txt-placeholder focus-within:!shadow-input-focus hover:shadow-input-hover focus-visible:shadow-input-focus active:shadow-input-focus disabled:cursor-not-allowed data-[status=disabled]:pointer-events-none data-[status=disabled]:bg-gray-tr-08 data-[status=disabled]:text-txt-disabled data-[status=error]:shadow-input-invalid data-[status=success]:shadow-input-success data-[status=error]:focus-within:!shadow-input-invalid data-[status=success]:focus-within:!shadow-input-success data-[status=error]:hover:shadow-input-invalid data-[status=success]:hover:shadow-input-success',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Textarea.displayName = 'Textarea'
Textarea.isFormControl = true

export { Textarea }
